import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { product } from '../data/product';
const benefits = ['✅ 6 Volumes', '✅ 5 Free Bonuses', '✅ 60 Printable Pages', '✅ Charts & Tools', '✅ Session Guides', '✅ Worksheets & Checklists'];
export const mockupUrl = 'https://cdn.magicpatterns.com/uploads/geeiTmkKftRyKZbuiMBAHm/Mockup_pendulum.png';
export function Hero() {
  return <>
    <section className="w-full bg-mist px-4 py-4 text-navy sm:py-6" data-id="element-112" data-mp="128fo9ew4a5tl">
      <div className="mx-auto max-w-5xl text-center" data-id="element-113" data-mp="xanqw5cpdri0">
        <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-amber" data-id="element-114" data-mp="xb5rfe6eervq">Pendulum Practice</motion.span>
        <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.05
        }} className="mx-auto mt-3 max-w-2xl font-serif text-3xl leading-[1.08] tracking-tight text-sage sm:text-5xl" data-id="element-115" data-mp="381e25e7i07uk">Stop searching. Start practicing with a complete, organized toolkit.</motion.h1>
        <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.16
        }} className="mx-auto mt-2.5 max-w-md text-sm leading-snug text-slate sm:text-base" data-id="element-116" data-mp="3e8efj63mtg2w">Learn pendulum techniques, read traditional charts, ask clearer questions, organize sessions, and use ready-to-print practical tools — all in one digital library.</motion.p>
        <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="mx-auto mt-4 max-w-3xl text-center" data-id="element-117" data-mp="2hj5clq725iyo">
          <p className="text-xs font-bold uppercase tracking-[0.12em] text-amber" data-id="element-118" data-mp="s3mb9x0ezovq">📦 Everything You Get Instantly</p>
          <ul className="mx-auto mt-2 grid w-fit grid-cols-2 gap-x-3 gap-y-1 text-left text-[11px] font-medium text-slate min-[380px]:text-xs sm:gap-x-8 sm:text-sm" data-id="element-119" data-mp="n98epra0nbph">{benefits.map(benefit => <li key={benefit} className="whitespace-nowrap" data-id="element-120" data-mp="deq92gl1h631">{benefit}</li>)}</ul>
        </motion.div>
        <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.26
        }} className="mx-auto mt-4 max-w-3xl" data-id="element-121" data-mp="1b0dt020b5vxo"><img src={mockupUrl} alt="Pendulum Dowsing Toolkit digital reference library mockup with volumes, tablet, printable charts, and pendulum" width={1254} height={1254} fetchPriority="high" decoding="async" className="mx-auto block aspect-square h-auto w-full max-w-[340px] rounded-2xl object-cover shadow-elevated sm:max-w-[420px]" data-id="element-122" data-mp="x14mju1wmg6w" /></motion.div>
        <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-5" data-id="element-123" data-mp="1xam4cnf59kxc"><CTAButton href="#complete-package" pulse size="large" data-id="element-124" data-mp="268ofhvsldtyc">GET INSTANT ACCESS</CTAButton><p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-slate sm:text-sm" data-id="element-125" data-mp="2b2aisxcv8lhh">📄 High-Quality PDFs <span className="mx-1" data-id="element-126" data-mp="2fzamj1m8tc5f">·</span> 🖨️ Printable Resources <span className="mx-1" data-id="element-127" data-mp="2kydtwspp3ugk">·</span> ⚡ Instant Download <span className="mx-1" data-id="element-128" data-mp="2kx2gs2ad1acs">·</span> 🔒 Secure Payment <span className="mx-1" data-id="element-129" data-mp="2ozz4u8io5yo4">·</span>  🛡️ 7-Day Purchase Protection</p></motion.div>
      </div>
    </section>
    <section className="border-y border-amber/40 bg-surface px-4 py-5 text-navy" data-id="element-130" data-mp="2tztuy9umek84"><div className="mx-auto max-w-3xl text-center" data-id="element-131" data-mp="umpopxvmbeww"><p className="text-sm font-bold sm:text-base" data-id="element-132" data-mp="uo0t9zww0qp2">🎁 Your Complete Digital Library — All 5 Exclusive Bonus Guides Included FREE</p><p className="mt-2 text-xs font-medium text-slate sm:text-sm" data-id="element-133" data-mp="znn8gewa0h0i">One organized collection of references, practice guides, session tools, and printable materials.</p><p className="mt-2 text-sm font-semibold text-sage" data-id="element-134" data-mp="3vgnk2zqt29uj">One-Time Payment — Only {product.priceLabel}</p></div></section>
  </>;
}